module.exports = __webpack_public_path__ + "static/img/2-6-普通拒收退货.5a2dd0d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jushuitan/2-6-普通拒收退货.png
// module id = 1318
// module chunks = 0